import React from 'react';
import { Grid, Typography, Button } from "@mui/material";
import { Grid as KendoGrid, GridColumn as KendoGridColumn } from '@progress/kendo-react-grid';
import DeleteButtonCell from "../delete-button-cell";
import TextboxCell from "../textbox-cell";
import {CurrencyCell} from "../currency-cell";

const MAX_POLICY_COUNT = 10;

const AddPolicyButton = ({policies, handleAddPolicy}) => {
    return policies.length <= MAX_POLICY_COUNT && (
        <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleAddPolicy}>
                Add Policy
            </Button>
        </Grid>
    )
}

const InsurancePolicies = (props) => {
    const policies = props.policies;

    const handleAddPolicy = () => {
        props.addPolicy();
    }

    const handleDelete = (item) => {
        props.deletePolicy(item);
    }

    return (
        <Grid className={"insurance-policies"} container spacing={3}>
            <Grid item xs={12}>
                <Typography variant='h1'>Insurance</Typography>
            </Grid>
            <AddPolicyButton policies={policies} handleAddPolicy={handleAddPolicy} />
            <Grid item xs={12}>
              <KendoGrid
                  data={policies}
                  onItemChange={(event) => {
                      const dataItem = event.dataItem;
                      const field = event.field;
                      const value = event.value;
                      props.update(field)(dataItem, value);
                  }}
              >
                  <KendoGridColumn field="policyOwner" title="Policy Owner" editable={true} cell={TextboxCell} />
                  <KendoGridColumn field="policyType" title="Policy Type" editable={true} cell={TextboxCell} />
                  <KendoGridColumn field="deathBenefitAmount" title="Death Benefit Amount" editable={true}  cell={CurrencyCell} />
                  <KendoGridColumn field="premium" title="Premium" editable={true} cell={CurrencyCell} />
                  <KendoGridColumn field="cashValue" title="Cash Value" editable={true}  cell={CurrencyCell} />
                  {policies.length > 1 && <KendoGridColumn cell={DeleteButtonCell(handleDelete)} title="" />}
              </KendoGrid>
            </Grid>
        </Grid>
    );
}

export default InsurancePolicies;
